module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "nav",
    class: {
      nav_space: !_vm.isItemsMoreThenTwo
    }
  }, [_vm._l((_vm.items), function(ref) {
    var to = ref.to;
    var target = ref.target;
    var text = ref.text;

    return [_c('div', {
      staticClass: "nav__item",
      class: {
        nav__item_space: !_vm.isItemsMoreThenTwo, nav__item_light: _vm.isCustomMainColor
      },
      on: {
        "click": function($event) {
          return _vm.clickElement(to)
        }
      }
    }, [_c('span', {
      staticClass: "nav__text"
    }, [_c('nobr', [_vm._v(_vm._s(text))])], 1)])]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef53ef00","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/header/addmenu/Addmenu.vue
// module id = 99c22b124a02e1da4fff
// module chunks = 8